var _Path, _Path2, _Path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgEthereum = function SvgEthereum(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m6.833 13.688 5.731 3.17v4.392l-5.73-7.562ZM6.833 12.663l5.731-2.444V3.75l-5.73 8.913Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "m6.833 12.663 5.731-2.444v5.62l-5.73-3.176ZM18.295 13.688l-5.731 3.17v4.392l5.73-7.562ZM18.295 12.663l-5.731-2.444V3.75l5.73 8.913Z",
    fill: "currentColor"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "m18.295 12.663-5.731-2.444v5.62l5.73-3.176Z",
    fill: "currentColor"
  })));
};
export default SvgEthereum;